import "../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22src%2Fviews%2Fhome%2Flogged-out-homepage%2F__internal__%2Fcomponents%2FTopHeaderBanner%2Fstyles.css.ts.vanilla.css%22%2C%22source%22%3A%22%23H4sIAAAAAAAAA6VUy26DMBC88xV7qZRIBdnGGOJe%2BitucMBRcCziKJYq%2Fr0CzKM0LUiV7Mvu7M7seOXInPVZnxB8BgCVqAulOWBm3FvQBFGfxH8lqU%2B68KFyW3JIYtoCAIzIc6ULDjQzDmLSR4c2CMTdXmeNkq6RLwov8mQ5kO%2BtwloV5RgeK1lX6XMDj5XOhuKiCs371Bi8lSK%2FPjhg47pLjYO6%2BBA79Ar%2BRCTZtwTvlcyVgNuxllKD0DnsKqWHSVOWGbeHjj2a%2BzhNOQzQTBC8DqEeMjrIWo2oR62pwqjt%2BFxWKXuTkgP%2BVdeAoZSsC0Otf9mAW5VGKVqTxkj2L2mzTaSJt3YmOENrTk71GJF4KZd4mhGCXnqG%2Bb4dpbay3kaSsnTJES%2FGJWizw34lt0yyZIkZ2%2FyOB%2FLjHZ%2F4P%2F4ETdB8Adb4ONxoBAAA%22%7D"
export var DESKTOP_BANNER_HEIGHT = 591;
export var DESKTOP_BANNER_WIDTH = 420;
export var MOBILE_BANNER_HEIGHT = 264;
export var MOBILE_BANNER_WIDTH = 355;
export var TABLET_BANNER_HEIGHT = 366;
export var TABLET_BANNER_WIDTH = 704;
export var XL_DESKTOP_BANNER_HEIGHT = 628;
export var XL_DESKTOP_BANNER_WIDTH = 698;
export var XXL_DESKTOP_BANNER_WIDTH = 842;
export var condensedContainer = 'pjnjnf1';
export var container = 'pjnjnf0';
export var credit = 'pjnjnf6';
export var halfBanner = 'pjnjnf2';
export var imageContainer = 'pjnjnf3';
export var leftContent = 'pjnjnf4';
export var leftContentCondensed = 'pjnjnf5';